import _ from "lodash";
import React, { Fragment, PureComponent } from "react";
import ACLStore from "lib/aclStore";
import classes from "./ResponsesComponent.scss";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import I18nHOC from "UIComponents/I18nHOC";
import FilterDropdown from "UIComponents/FilterDropdown";
import { colors } from "Constants";
import PropTypes from "prop-types";
import ResponsesEdit from "./ResponsesEdit";
import { getUserCoursesFilters } from "UnitPlans/modules/Utils";
import ResponsesView from "./ResponsesView";
import { getUserCoursesQueryEnhancer } from "../../../modules/UnitPlanQueryEnhancers";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import classNames from "classnames";

const getPermittedCourseList = ({ unitPlanCourses, userCourses }) => {
  const allCourses = _.get(userCourses, "courses", []);
  const courses = _.filter(allCourses, { isDemo: false });
  // List of courses which the user is part of and the current
  // unit plan is shared with.
  return _.intersectionBy(unitPlanCourses, courses, "id");
};

const getPermittedCourseListMemoized = _.memoize(
  params => getPermittedCourseList(params),
  params => JSON.stringify(params.unitPlanCourses)
);

const styles = {
  courseButtonDropDownContainer: {
    top: 48,
    width: "100%",
    minWidth: 200,
    maxHeight: 300,
    overflowY: "auto",
  },
  filterBox: {
    width: "100%",
    height: 48,
    borderRadius: 4,
    flex: 1,
  },
  filterText: {
    color: colors.neutral400,
    fontSize: "1.6rem",
    lineHeight: "2.6rem",
  },
  buttonParent: { flex: 1 },
  parentContainer: { flex: 1 },
};

class ResponsesComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedCourseIds: [],
      permittedCourses: [],
    };
  }

  componentDidMount() {
    const { currentCourseId, unitPlanCourses, userCourses } = this.props;
    // Calculate permitted courses
    const permittedCourses = !_.isEmpty(currentCourseId)
      ? getPermittedCourseListMemoized({
          unitPlanCourses,
          userCourses,
        })
      : unitPlanCourses;

    this.setState({ permittedCourses });

    if (currentCourseId && this.checkCourseFilterVisibility()) {
      this.setState({
        selectedCourseIds: [currentCourseId],
      });
    }
  }

  getPermittedCourseListForFilter = () => {
    const { permittedCourses } = this.state;
    return _.map(permittedCourses, course => ({
      value: course.id,
      label: course.title,
    }));
  };

  updateSelectedCourses = ({ selectedCourseIds }) => {
    this.setState({ selectedCourseIds });
  };

  customRef = ref => {
    const { customRef } = this.props;
    customRef(ref);
  };

  checkCourseFilterVisibility = () => {
    const { userInfo, isReflectionField, showFilterOnResponses } = this.props;
    const { user_type: userType } = userInfo;

    return (
      ACLStore.can("TeacherPortal:UnitPlanSectionSharing") &&
      isReflectionField &&
      showFilterOnResponses &&
      _.isEqual(userType, "staff")
    );
  };

  render() {
    const {
      t,
      mode,
      responses = [],
      isToddlePlay = false,
      onMediaClick,
      userInfo,
      onEditClickFromViewMode,
      fieldId,
      showResponseEditButton,
      isSinglePageAndNewUnitView,
      isReflectionField,
      parentId,
      unitPlanId,
      filterContainerClass,
    } = this.props;
    const { selectedCourseIds } = this.state;

    const courseList = this.getPermittedCourseListForFilter();
    const showCourseFilter = this.checkCourseFilterVisibility();

    // HACK: This prop is for withLoader which handles case for
    // jitter (PLN: 152) caused due to default styling and filter.
    // Basically it handles the case when filter is present by giving
    // a certain styling.
    const loadingContainerStyle = showCourseFilter
      ? { marginTop: 150, marginBottom: 150 }
      : { marginTop: 50, marginBottom: 50 };
    const userType = _.get(userInfo, "user_type", "");
    return mode == "edit" ||
      (isSinglePageAndNewUnitView && _.isEqual(userType, "student")) ? (
      <Fragment>
        {showCourseFilter && (
          <div
            className={classNames(
              classes.filterContainer,
              filterContainerClass
            )}
          >
            <FilterDropdown
              options={courseList}
              showAllOption={false}
              labelElement={`${t("common:showing_with_label", {
                label: t("common:class_plural"),
              })}: `}
              name={"selectedCourseIds"}
              value={selectedCourseIds}
              filterBoxStyle={styles.filterBox}
              filterTextStyle={styles.filterText}
              buttonParentStyle={styles.buttonParent}
              parentContainerStyle={styles.parentContainer}
              allOptionLabel={t("common:all_with_label", {
                label: t("common:course_plural"),
              })}
              noOptionLabel={t("common:all_with_label", {
                label: t("common:course_plural"),
              })}
              buttonDropDownContainerStyle={
                styles.courseButtonDropDownContainer
              }
              updateInputField={this.updateSelectedCourses}
            />
          </div>
        )}
        <ResponsesEdit
          isSinglePageAndNewUnitView={isSinglePageAndNewUnitView}
          customRef={this.customRef}
          selectedCourseIds={selectedCourseIds}
          {..._.omit(this.props, [])}
          showCourseFilter={showCourseFilter}
          loadingContainerStyle={loadingContainerStyle}
          isReflectionField={isReflectionField}
          isStudentView={_.isEqual(userType, "student")}
          parentId={parentId || unitPlanId}
        />
      </Fragment>
    ) : isSinglePageAndNewUnitView ? (
      !_.isEmpty(responses) ? (
        <ResponsesView
          isSinglePageAndNewUnitView={isSinglePageAndNewUnitView}
          value={responses}
          isToddlePlay={isToddlePlay}
          onMediaClick={onMediaClick}
          userInfo={userInfo}
          onEditClickFromViewMode={onEditClickFromViewMode}
          fieldId={fieldId}
          showResponseEditButton={showResponseEditButton}
          mode={mode}
        />
      ) : (
        isReflectionField && (
          <span className={classNames("text-body", classes.emptyTextContainer)}>
            {t("unitPlan:no_reflections_added")}
          </span>
        )
      )
    ) : (
      <ResponsesView
        value={responses}
        isToddlePlay={isToddlePlay}
        onMediaClick={onMediaClick}
        userInfo={userInfo}
        onEditClickFromViewMode={onEditClickFromViewMode}
        fieldId={fieldId}
        showResponseEditButton={showResponseEditButton}
        mode={mode}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { options, responses, unitPlanCourses, mode } = ownProps;
  const isToddlePlay = _.get(state, "unitPlans.isToddlePlay", false);
  const {
    currentCurriculumProgram,
    organizationCurriculumPrograms,
  } = state.platform;
  const userInfo = getUserInfo();

  const responseNodes = _.map(
    _.get(responses, "edges", []),
    _.iteratee("node")
  );

  const currentCourseId = _.get(
    state.teacher,
    "selected_class.selected_course",
    null
  );

  const userEntityType = userInfo.userEntityType;

  const courseFilters = {
    ...getUserCoursesFilters({
      currentCurriculumProgramId: currentCurriculumProgram.id,
      organizationCurriculumPrograms,
    }),
  };

  const shouldFetchCourses =
    ACLStore.can("TeacherPortal:UnitPlanSectionSharing") &&
    _.isEqual(mode, "edit");

  const userCoursesVariables = {
    id: userInfo.id,
    type: userEntityType,
    filters: courseFilters,
    shouldSkipUserCourseQuery: !shouldFetchCourses,
    portalType: "PLANNER",
  };

  return {
    currentCourseId,
    responses: responseNodes,
    options: JSON.parse(options),
    userInfo,
    isToddlePlay,
    userCoursesVariables,
    unitPlanCourses,
  };
};

const ResponsesComponentWrapper = compose(
  I18nHOC({ resource: ["unitPlan", "common"] }),
  connect(mapStateToProps, null),
  getUserCoursesQueryEnhancer
)(ResponsesComponent);

ResponsesComponentWrapper.propTypes = {
  label: PropTypes.string,
  subText: PropTypes.string,
  labelStyle: PropTypes.object,
  labelComponent: PropTypes.element,
  responses: PropTypes.object,
  errorStyle: PropTypes.object,
  customValidation: PropTypes.func,
  error: PropTypes.string,
  mode: PropTypes.string,
};

ResponsesComponentWrapper.defaultProps = {
  label: "",
  subText: "",
  labelStyle: {},
  mode: "edit",
};

export default ResponsesComponentWrapper;
